import { CanActivateFn } from '@angular/router';
import { isFuture, startOfDay } from 'date-fns';

export const canActivateAddTurnoverDialog: CanActivateFn = (route) => {
  const date = route.params['date'];
  if (!date) return true;
  const parsedDate = new Date(date);
  // is invalid date
  if (isNaN(parsedDate.getDate())) return false;
  return !isFuture(startOfDay(parsedDate));
};
